import React, {useContext, useEffect, useState} from "react";
import {Box, Chip, Grid, Typography} from "@mui/material";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import {getDataBetweenDates, getMonthStartDate, getMonthEndDate, getMonthName} from "../../utils/dates";
import Progress from "../../components/progress/progress";

import question from "../../assets/images/question.svg";
import info from "../../assets/images/info.svg";
import "./dashboard.css";
import {useRefData} from "../../graphql/graphql/ref/hooks";
import {useVarAuth} from "../../graphql/graphql/auth/defaults";
import {CustomTooltip} from "../../components/CustomTooltip";

const MembershipCards = () => {
  const {user} = useVarAuth();
  const [memberCardData, setMemberCardData] = useState([]);
  const {data} = useRefData();
  useEffect(() => {
    if (data) {
      const subscriptionEndDate = new Date(user.planEnds);
      const monthName = getMonthName(subscriptionEndDate.getMonth());
      const nextSubscriptionStartDate = `${monthName} ${subscriptionEndDate.getDate()}`;
      const {
        activeReferralCount,
        allCreatedReferrals,
        allCreatedReferralsThisMonth,
        newReferralCountThisDay,
        // sumOfCreditsToActiveReferral,
        // sumOfCreditsToActiveReferralInDollars,
      } = data;
      //console.log("🚀 ~ file: membershipCards.jsx:36 ~ useEffect ~ data", data);
      setMemberCardData([
        {
          title: "membership",
          icon: question,
          tool: "Your membership status, renewal date, and discounts if applicable. A 33% discount is applied every time someone signs up using your referral link.",
          // label: user.stripeSubscriptionId ? "PRO" : "",
          label: "PRO",

          chip:
            activeReferralCount >= 3
              ? "100% off"
              : activeReferralCount === 2
              ? "66% off"
              : activeReferralCount === 1
              ? "33% off"
              : undefined,
          arrowIcon: false,
          refTitle: `${activeReferralCount >= 3 ? "3+" : activeReferralCount} ref active.`,
          refDesc:
            activeReferralCount === 0
              ? `Renews ${nextSubscriptionStartDate}`
              : activeReferralCount === 1
              ? `Renews ${nextSubscriptionStartDate} (33% off)`
              : activeReferralCount === 2
              ? `Renews ${nextSubscriptionStartDate} (66% off)`
              : `Renews ${nextSubscriptionStartDate} (FREE)`,
          progressLabel: "",
          progressBar: false,
        },
        {
          title: "ACTIVE REFERRALS",
          icon: question,
          tool: "This is the number of active members who signed up using your link. This does not include those members who've cancelled.",
          label: activeReferralCount,
          chip: false,
          arrowIcon: true,
          refTitle: `${newReferralCountThisDay} referrals`,
          refDesc: "1D",
          // progressLabel: "5 referrals 'til silver",
          progressBar: true,
        },
        {
          title: "CREDITS EARNED",
          icon: question,
          tool: "10 credits equals $1.00. Credits earned is 15% of what they paid times 10 (i.e. if a member uses your link and gets 20% off their first month: 60 * 0.80 * 0.15 * 10 = 72 credits).",
          label: allCreatedReferrals,
          chip: false,
          arrowIcon: true,
          refTitle: allCreatedReferralsThisMonth,
          refDesc: "this month",
          progressLabel: "",
          progressBar: false,
        },
      ]);
    }
  }, [data]);

  // useEffect(() => {
  //   const lastMonthStartDate = getMonthStartDate(1);
  //   const lastMonthEndDate = getMonthEndDate(1);
  //   const currentMonthStartDate = getMonthStartDate(0);
  //   const currentMonthEndDate = getMonthEndDate(0);
  //   const nextMonthStartDate = new Date(getMonthStartDate(1, "next")).getDate();
  //   const montlyRefUser = {
  //     lastMonth: getDataBetweenDates(
  //       referralData,
  //       lastMonthStartDate,
  //       lastMonthEndDate
  //     ),
  //     currentMonth: getDataBetweenDates(
  //       referralData,
  //       currentMonthStartDate,
  //       currentMonthEndDate
  //     ),
  //   };
  //   const getTodaysRef = referralData?.filter(
  //     (refData) => new Date(refData?.Date).getDate() == new Date().getDate()
  //   );
  //   const activeReferral = referralData?.filter(
  //     (refData) => refData?.stripeSubscriptionId
  //   )?.length;
  //   const allSubscription = referralData.filter(
  //     (refData) => refData?.stripeSubscriptionId && refData.planPrice
  //   );
  //   const totalPrice = allSubscription.length
  //     ? allSubscription
  //         .map((item) => item.planPrice)
  //         .reduce((prev, next) => prev + next)
  //     : 0;
  //   console.log(
  //     "🚀 ~ file: membershipCards.jsx:28 ~ useEffect ~ totalPrice",
  //     totalPrice
  //   );

  //   setMemberCardData([
  //     {
  //       title: "membership",
  //       icon: question,
  //       label: user.stripeSubscriptionId ? "PRO" : "",
  //       chip:
  //         referralData.length >= 3
  //           ? "FREE"
  //           : referralData?.length === 2
  //           ? "66% off"
  //           : referralData.length === 1
  //           ? "33% off"
  //           : undefined,
  //       arrowIcon: false,
  //       refTitle: `${activeReferral}+ referrals active`,
  //       refDesc:
  //         activeReferral === 0
  //           ? `Next payment ${getMonthName(nextMonthStartDate)} 1`
  //           : activeReferral === 1
  //           ? `Next payment ${getMonthName(nextMonthStartDate)} 1 with 33% off`
  //           : activeReferral === 2
  //           ? `Next payment ${getMonthName(nextMonthStartDate)} 1 with 66% off`
  //           : "",
  //       progressLabel: "",
  //       progressBar: false,
  //     },
  //     {
  //       title: "ACTIVE REFERRALS",
  //       icon: info,
  //       label: "0",
  //       chip: false,
  //       arrowIcon: true,
  //       refTitle: `${getTodaysRef?.length} referrals`,
  //       refDesc: "1D",
  //       progressLabel: "5 referrals 'til silver",
  //       progressBar: true,
  //     },
  //     {
  //       title: "CREDITS EARNED",
  //       icon: info,
  //       label: totalPrice * 0.15 * 10,
  //       chip: false,
  //       arrowIcon: true,
  //       refTitle:
  //         montlyRefUser?.currentMonth?.length - montlyRefUser?.lastMonth.length,
  //       refDesc: "this month",
  //       progressLabel: "",
  //       progressBar: false,
  //     },
  //   ]);
  // }, [referralData.length]);

  return (
    <Grid container spacing={{xs: 2, xl: 3}}>
      {memberCardData.map((member, key) => (
        <Grid item xs={12} md={6} lg={4} key={key}>
          <Box className="membershipCards">
            <Box className="cardHeader">
              <Typography variant="h5">{member.title}</Typography>
              <CustomTooltip title={member.tool}>
                <img src={member.icon} alt="info" />
              </CustomTooltip>
            </Box>
            <Box className="memberLabel">
              <Typography variant="h5">{member.label}</Typography>
              {member.chip && <Chip icon={<VerifiedOutlinedIcon />} label={member.chip} />}
            </Box>
            <Box className="memberReferral" display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="h4" mr={2}>
                {member.arrowIcon && <KeyboardArrowUpOutlinedIcon sx={{fontSize: "18px"}} />}
                {member.refTitle} <span>{member.refDesc}</span>
              </Typography>
              {member.progressBar && (
                <Box>
                  <Typography>{member.progressLabel}</Typography>
                  <Progress value={80} />
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default MembershipCards;
